export default __webpack_public_path__ + "static/media/back.a660fc16.svg";